// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}
a {
  color: inherit;
  text-decoration: inherit;
}
/* By default, use box-sizing: border box */
*,
*::before,
*::after {
  box-sizing: inherit;
}

*:focus:not(iframe) {
  outline: 3px solid gold;
}

html {
  box-sizing: border-box;
  scroll-behavior: smooth;
}
/* -------------------------------------- */

html { /* Prevent font scaling in landscape while allowing user zoom */
  text-size-adjust: 100%;
}

body {
  margin: 0;

  font-family: "Kumbh Sans", sans-serif; /* this font style is applied */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

span,
p,
h1,
h2,
h3,
h4,
h5,
li,
small {
  color: var(--dark);
}

img:not(.iconSvg) {
  border-radius: 8px;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

a {
  color: var(--dark);
  text-decoration: inherit;
}

/* Button styles reset */
button,
input[type="submit"] {
  background-color: transparent;
  border-width: 0;
  font-family: inherit;
  font-size: inherit;
  font-style: inherit;
  font-weight: inherit;
  line-height: inherit;
  padding: 0;
}
/* ------------------- */

:root {
  --white: #fff;
  --light: #fffdf5;
  --dark: #14320c;
  --dark-muted: hsl(107, 35%, 12%);
  --gold: #ffcc00;
  --softyellow: #fdf39f;
  --box-shadow: 0px 0px 6px rgba(20, 50, 12, 0.15);
  --box-shadow-darker: 0px 0px 6px rgba(20, 50, 12, 0.25);
  --shadow: drop-shadow(2px 2px 4px rgba(20, 50, 12, 0.25)); /* this RGBA is just the dark hex value with alpha set to 0.25*/
  --shadow-muted: drop-shadow(2px 2px 4px rgba(20, 50, 12, 0.15));
  --shadow-down: drop-shadow(2px 2px 4px rgba(20, 50, 12, 0.25));
}
.german {
  --white: yellow;
  --light: black;
  --dark: red;
  --dark-muted: #ffffff;
  --gold: #ffcc00;
  --box-shadow: 0px 0px 6px rgba(20, 50, 12, 0.15);
  --shadow: drop-shadow(2px 2px 4px rgba(20, 50, 12, 0.25)); /* this RGBA is just the dark hex value with alpha set to 0.25*/
  --shadow-muted: drop-shadow(2px 2px 4px rgba(20, 50, 12, 0.15));
  --shadow-down: drop-shadow(2px 2px 4px rgba(20, 50, 12, 0.25));
}
`, "",{"version":3,"sources":["webpack://./src/css/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,8JAA8J;EAC9J,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,+EAA+E;AACjF;AACA;EACE,cAAc;EACd,wBAAwB;AAC1B;AACA,2CAA2C;AAC3C;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA,2CAA2C;;AAE3C,OACkC,+DAA+D;EAC/F,sBAAsB;AACxB;;AAEA;EACE,SAAS;;EAET,qCAAqC,EAAE,+BAA+B;EACtE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;;;;;;;;EASE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,wBAAwB;AACxB;;EAEE,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,UAAU;AACZ;AACA,wBAAwB;;AAExB;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,qBAAqB;EACrB,gDAAgD;EAChD,uDAAuD;EACvD,yDAAyD,EAAE,+DAA+D;EAC1H,+DAA+D;EAC/D,8DAA8D;AAChE;AACA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,gDAAgD;EAChD,yDAAyD,EAAE,+DAA+D;EAC1H,+DAA+D;EAC/D,8DAA8D;AAChE","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\na {\n  color: inherit;\n  text-decoration: inherit;\n}\n/* By default, use box-sizing: border box */\n*,\n*::before,\n*::after {\n  box-sizing: inherit;\n}\n\n*:focus:not(iframe) {\n  outline: 3px solid gold;\n}\n\nhtml {\n  box-sizing: border-box;\n  scroll-behavior: smooth;\n}\n/* -------------------------------------- */\n\nhtml {\n  -webkit-text-size-adjust: 100%; /* Prevent font scaling in landscape while allowing user zoom */\n  text-size-adjust: 100%;\n}\n\nbody {\n  margin: 0;\n\n  font-family: \"Kumbh Sans\", sans-serif; /* this font style is applied */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nspan,\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nli,\nsmall {\n  color: var(--dark);\n}\n\nimg:not(.iconSvg) {\n  border-radius: 8px;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\na {\n  color: var(--dark);\n  text-decoration: inherit;\n}\n\n/* Button styles reset */\nbutton,\ninput[type=\"submit\"] {\n  background-color: transparent;\n  border-width: 0;\n  font-family: inherit;\n  font-size: inherit;\n  font-style: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  padding: 0;\n}\n/* ------------------- */\n\n:root {\n  --white: #fff;\n  --light: #fffdf5;\n  --dark: #14320c;\n  --dark-muted: hsl(107, 35%, 12%);\n  --gold: #ffcc00;\n  --softyellow: #fdf39f;\n  --box-shadow: 0px 0px 6px rgba(20, 50, 12, 0.15);\n  --box-shadow-darker: 0px 0px 6px rgba(20, 50, 12, 0.25);\n  --shadow: drop-shadow(2px 2px 4px rgba(20, 50, 12, 0.25)); /* this RGBA is just the dark hex value with alpha set to 0.25*/\n  --shadow-muted: drop-shadow(2px 2px 4px rgba(20, 50, 12, 0.15));\n  --shadow-down: drop-shadow(2px 2px 4px rgba(20, 50, 12, 0.25));\n}\n.german {\n  --white: yellow;\n  --light: black;\n  --dark: red;\n  --dark-muted: #ffffff;\n  --gold: #ffcc00;\n  --box-shadow: 0px 0px 6px rgba(20, 50, 12, 0.15);\n  --shadow: drop-shadow(2px 2px 4px rgba(20, 50, 12, 0.25)); /* this RGBA is just the dark hex value with alpha set to 0.25*/\n  --shadow-muted: drop-shadow(2px 2px 4px rgba(20, 50, 12, 0.15));\n  --shadow-down: drop-shadow(2px 2px 4px rgba(20, 50, 12, 0.25));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
